import { css } from '@emotion/react';
import { type Env0Theme } from 'constants/themes.constants';
import styled from 'types/theme.types';

interface Props {
  gap?: number;
}

type StackArgs = Props & { theme: Env0Theme };

const newDesignGap = (props: StackArgs) => css`
  display: flex;
  flex-direction: column;
  gap: ${props.gap !== undefined ? `${props.gap}px` : props.theme.spacing.xxl};
`;

const Stack = styled.div<Props>`
  ${newDesignGap}
`;

export default Stack;
